import React from 'react';

const ProcessSection = () => {
  const steps = [
    {
      number: '1',
      title: 'Discover',
      description: 'Quick call + environment overview.',
      color: 'from-blue-500 to-blue-600',
    },
    {
      number: '2',
      title: 'Assess',
      description: 'We identify risks, gaps, and quick wins.',
      color: 'from-cyan-400 to-cyan-500',
    },
    {
      number: '3',
      title: 'Stabilize',
      description: 'We implement baselines, monitoring, backups, and ticketing.',
      color: 'from-blue-500 to-blue-600',
    },
    {
      number: '4',
      title: 'Maintain + Improve',
      description: 'Ongoing support, patching, reporting, and roadmap.',
      color: 'from-cyan-400 to-cyan-500',
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-cyan-500 uppercase tracking-wide mb-2">
            Our Process
          </p>
          <h2 className="text-4xl font-bold text-gray-900">How It Works</h2>
        </div>

        <div className="grid md:grid-cols-4 gap-8 relative">
          {/* Connecting Lines */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-200 via-cyan-200 to-blue-200" style={{ top: '60px', left: '12.5%', right: '12.5%', width: '75%' }}></div>

          {steps.map((step, index) => (
            <div key={index} className="relative text-center">
              <div className={`w-24 h-24 mx-auto bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center mb-6 shadow-lg relative z-10`}>
                <span className="text-3xl font-bold text-white">{step.number}</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;